import React, { Component } from "react";
import '../css/KpointPlayer.css';

class KpointPlayer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      kPlayer: null,
    };
  }

  componentDidMount() {
    const script = document.createElement("script");
    script.src = "https://ktpl.kpoint.com/assets/orca/media/embed/player-silk.js";
    script.async = true;
    document.body.appendChild(script);

    script.onload = () => {
      window.onkPointPlayerReady = (player) => {
        this.setState({ kPlayer: player }, () => {
          if (this.props.onPlayerReady) {
            this.props.onPlayerReady(player);
          }
        });

        if (this.props.onTimeupdate) {
          player.addEventListener(player.events.timeUpdate, this.props.onTimeupdate);
        }
        if (this.props.onStateChange) {
          player.addEventListener(player.events.onStateChange, this.props.onStateChange);
          
        }
      };
    };
  }

  seekTo = (seconds) => {
    if (this.state.kPlayer) {
      try {
        this.state.kPlayer.seekTo(seconds);
      } catch (error) {
        console.error("Error seeking to time:", error);
      }
    } else {
      console.error("Player not initialized");
    }
  }

  render() {
    return (
      <div
        data-video-host={this.props.videoHost}
        data-kvideo-id={this.props.videoId}
        data-host-url={this.props.hostUrl}
        data-video-params={JSON.stringify(this.props.videoParams)}
        data-player={this.props.playerId}
        style={{ width: this.props.width }}
      />
    );
  }
}

export default KpointPlayer;